export default "__VITE_ASSET__78d78d99__"